import { createContext } from 'react';

// Create the context
const AuthorizationContext = createContext({
  isAllowedTo: () => false,
});

export default AuthorizationContext;
